import React from 'react';
import PropTypes from 'prop-types';
import CardDataItem from './CardDataItem';

const PaymentDetails = ({
  paymentType,
  providedService,
  capInformation,
  unit,
}) => {
  const CostBasedReimbursementDetails = () => (
    <>
      <CardDataItem
        dataLabel="unit-amount-value"
        label="Cost"
        required={!providedService.unit_amount}
        value={providedService.unit_amount || 'Required'}
        amountField
      />
      <CardDataItem
        isHTML
        label="Cap"
        value={capInformation}
      />
    </>
  );

  const FundsDistributedDetails = () => (
    <>
      <CardDataItem
        dataLabel="unit-amount-value"
        label="Amount Distributed"
        required={!providedService.unit_amount}
        value={providedService.unit_amount || 'Required'}
        amountField
      />
      <CardDataItem
        dataLabel="payment-method-value"
        label="Distribution Method"
        value={providedService.payment_method}
      />
      <CardDataItem
        dataLabel="distribution-reason-value"
        label="Reason for Distribution"
        value={providedService.distribution_reason}
      />
      {providedService.distribution_id && (
        <CardDataItem
          dataLabel="distribution-id-value"
          label="Payment Distribution ID"
          value={providedService.distribution_id}
        />
      )}
      <CardDataItem
        dataLabel="payee-select-value"
        label="Payee"
        value={providedService.payee}
      />
    </>
  );

  const TimeBasedDetails = () => (
    <>
      <CardDataItem
        dataLabel="unit-amount-value"
        label="Unit Amount"
        required={!providedService.unit_amount && providedService.unit_amount !== 0}
        value={(!providedService.unit_amount && providedService.unit_amount !== 0) ?
          'Required' : providedService.unit_amount}
      />
      <CardDataItem
        dataLabel="unit-value"
        label="Unit"
        required={!unit}
        value={unit || 'Required'}
      />
    </>
  );

  const DefaultPaymentDetails = () => (
    <>
      <CardDataItem
        dataLabel="unit-amount-value"
        label="Unit Amount"
        required={!providedService.unit_amount}
        value={providedService.unit_amount || 'Required'}
      />
      <CardDataItem
        dataLabel="unit-value"
        label="Unit"
        required={!unit}
        value={unit || 'Required'}
      />
    </>
  );

  switch (paymentType) {
    case 'cost_based_reimbursement':
      return <CostBasedReimbursementDetails />;
    case 'funds_distributed':
      return <FundsDistributedDetails />;
    case 'time_based':
      return <TimeBasedDetails />;
    default:
      return <DefaultPaymentDetails />;
  }
};

PaymentDetails.propTypes = {
  paymentType: PropTypes.string.isRequired,
  providedService: PropTypes.shape({
    unit_amount: PropTypes.number,
    actual_unit_amount: PropTypes.number,
    payment_method: PropTypes.string,
    distribution_reason: PropTypes.string,
    distribution_id: PropTypes.string,
    payee: PropTypes.string,
  }).isRequired,
  capInformation: PropTypes.string,
  unit: PropTypes.string,
};

PaymentDetails.defaultProps = {
  capInformation: '',
  unit: '',
};

export default PaymentDetails;
